module.exports = __webpack_public_path__ + "img/logo-reverse-mono.b266063f.svg";